import { Screen } from '~/screens/users/new';

export const UserNew: React.FC = () => <Screen />;
